import React, { useEffect, useState } from 'react';
import { BellRing, X } from 'lucide-react';
import { toast } from 'sonner';
import { enableWebPush, syncWebPush, webPushSupported } from '../lib/webPush';

const SNOOZE_KEY = 'ar_push_prompt_snooze_until';

const WebPushPrompt = ({ api, isAres = false }) => {
  const [visible, setVisible] = useState(false);
  const [activating, setActivating] = useState(false);

  useEffect(() => {
    if (!webPushSupported()) return undefined;
    if (Notification.permission === 'granted') {
      syncWebPush(api).catch(() => {});
      return undefined;
    }
    if (Notification.permission === 'denied') return undefined;
    const snoozedUntil = Number(window.localStorage.getItem(SNOOZE_KEY) || 0);
    if (snoozedUntil > Date.now()) return undefined;
    const timer = window.setTimeout(() => setVisible(true), 1200);
    return () => window.clearTimeout(timer);
  }, [api]);

  const activate = async () => {
    setActivating(true);
    try {
      await enableWebPush(api);
      setVisible(false);
      toast.success('Notificaciones activadas', { description: 'Recibirás avisos de AR Gestión y Ares aunque cierres la app.' });
    } catch (error) {
      toast.error('No fue posible activar los avisos', { description: error?.message || 'Revisa el permiso de notificaciones del dispositivo.' });
    } finally {
      setActivating(false);
    }
  };

  const postpone = () => {
    window.localStorage.setItem(SNOOZE_KEY, String(Date.now() + (7 * 24 * 60 * 60 * 1000)));
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <aside className={`fixed inset-x-3 bottom-20 z-[70] mx-auto max-w-lg rounded-2xl border p-3 shadow-2xl backdrop-blur-xl lg:bottom-5 ${isAres ? 'border-[#b9954f]/50 bg-[#111]/95 text-white' : 'border-[#e5cdd2] bg-white/95 text-slate-950'}`} aria-label="Activar notificaciones">
      <div className="flex items-start gap-3">
        <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${isAres ? 'bg-[#b9954f]/20 text-[#d6b76f]' : 'bg-[#8A1C2C]/10 text-[#8A1C2C]'}`}><BellRing className="h-5 w-5" /></span>
        <div className="min-w-0 flex-1">
          <p className="font-semibold">Recibe avisos en este dispositivo</p>
          <p className={`mt-0.5 text-xs leading-5 ${isAres ? 'text-slate-300' : 'text-slate-600'}`}>AR Gestión y Ares te avisarán aunque la app esté cerrada. Al tocar el aviso abrirás la tarea correspondiente.</p>
          <button type="button" disabled={activating} onClick={activate} className={`mt-2 min-h-10 rounded-xl px-4 text-sm font-semibold text-white disabled:opacity-60 ${isAres ? 'bg-[#9c7835]' : 'bg-[#8A1C2C]'}`}>{activating ? 'Activando…' : 'Activar avisos'}</button>
        </div>
        <button type="button" onClick={postpone} className="rounded-lg p-1.5 opacity-60 hover:opacity-100" aria-label="Recordar después"><X className="h-4 w-4" /></button>
      </div>
    </aside>
  );
};

export default WebPushPrompt;
